<lib-loader-overlay [loading]="loading()"></lib-loader-overlay>

<router-outlet></router-outlet>
